import { render, staticRenderFns } from "./chat_message.vue?vue&type=template&id=08a271d5&scoped=true"
import script from "./chat_message.vue?vue&type=script&lang=js"
export * from "./chat_message.vue?vue&type=script&lang=js"
import style0 from "./chat_message.vue?vue&type=style&index=0&id=08a271d5&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a271d5",
  null
  
)

export default component.exports